export default __webpack_public_path__ + "static/media/loading.8417ad7b.gif";